<!--
 * @Description: 退出登录
 * @Date: 2019-10-29 10:21:46
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-11-06 10:54:11
 -->

<template>
  <div style="display: inline-block;"  >
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
      top
      class="content__"
    >
      <template v-slot:activator="{ on }">
        <v-btn text icon color="green" v-on="on" style="margin-left: 10px;margin-top: 3px;">
              <v-icon>insert_comment</v-icon>
        </v-btn>
      </template>
      <v-card width="400" height="400" >
        <v-list v-for="(item, index) in valueList" :key="index" style="padding: 0 0;" >
          <v-list-item>
            <v-list-item-avatar>
              <span v-if="item"> {{ item[0] }} </span>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-subtitle >
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <span color="primary" dark v-on="on">{{item}}</span>
                    </template>
                    <span>{{ item }}</span>
                  </v-tooltip>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn
                :class="fav ? 'green--text' : ''"
                icon
                @click="submit(index)"
              >
                <v-icon>chat</v-icon>
              </v-btn>
            </v-list-item-action>
            <v-list-item-action>
              <v-btn
                :class="fav ? 'red--text' : ''"
                icon
                @click="delete_(index)"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="show">
              <v-icon>add_box</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
    <!-- 添加弹出框 -->
    <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          添加快捷回复
        </v-card-title>

        <v-card-text>
            <p></p>
                  <v-textarea
                    outlined
                    name="input-7-4"
                    :label="`* 快捷回复内容`"
                    color="black"
                    :no-resize="true"
                     maxlength="200"
                     counter="200"
                    v-model.trim="valueText"
                  ></v-textarea>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="add"
          >
           + 添加
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      fav: true,
      menu: false,
      message: false,
      hints: true,
      dialog: false,
      valueText:'',
      valueList: []
    };
  },
 
   mounted: function() {
       if( this.$cookie.getLocalStorage('Quick') ){
            this.valueList = this.$cookie.getLocalStorage('Quick');
       }
  },
  methods: {
      /* 发送 */   
      submit(index){
          this.$parent.$parent.$parent.quick( this.valueList[index] );
      },
      // 删除 
      delete_(index){
          this.dialog = false;
          let list = this.$cookie.getLocalStorage('Quick');
          list.splice(index,1);
          this.$cookie.setLocalStorage( 'Quick', JSON.stringify([...list]) );
          setTimeout(()=>{
            this.valueList = this.$cookie.getLocalStorage('Quick');
          },300)
      },
    /* 添加快捷回复按钮 */   
      add(){
          this.dialog = false;
          let list = this.$cookie.getLocalStorage('Quick');
          // 已存在
          if( this.$cookie.getLocalStorage('Quick') ){
              list.push(`${this.valueText}`);
              this.$cookie.setLocalStorage( 'Quick', JSON.stringify([...list]) );
              setTimeout(()=>{
                  this.valueText = "";
                  this.valueList = this.$cookie.getLocalStorage('Quick');
              },300)
          // 不存在
          }
      },
    /* 添加快捷回复弹框 */   
    show() {
        this.menu = false;
        this.dialog = true;
    },
    out(){
        // user_logout
         this.$axios({
        method: "post",
        url: this.$apis.URL.user_logout,
        data: {}
      })
        .then(req => {
          if (req.data.result == 0) {
            window.console.log( req.data.datas )
            this.$Dialog.getProductCheckResult_({ text: `已安全退出登录！`, timeout: 3000, snackbar: true });
            this.$router.push({
                  path: `/`,
                  query: {}
                });
          } else {
            this.$Dialog.getProductCheckResult_({ text: req.data.message, timeout: 3000, snackbar: true });
          }
        })
        .catch(error => {
          this.$Dialog.getProductCheckResult_({ text: error, timeout: 3000, snackbar: true });
        });
    }
  }
};
</script>

<style>
.v-menu__content::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 3px;
  /*高宽分别对应横竖滚动条的尺寸*/
  background: #ebeef5;
  -webkit-box-shadow: inset 1px 0 1px rgba(0, 0, 0, 0.2);
}

.v-menu__content::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.6);
  height: 120px;
}

.v-menu__content::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.1);
}

.v-menu__content::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 3px;
  /*高宽分别对应横竖滚动条的尺寸*/
  background: #ebeef5;
  -webkit-box-shadow: inset 1px 0 1px rgba(0, 0, 0, 0.2);
}

.v-menu__content::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.2);
  height: 120px;
}

.v-menu__content::-webkit-scrollbar-track{
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
  border-radius: 2px;
  background: #fff;
}
</style>